var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"users"},[_c('ul',_vm._l((_vm.users),function(user){return _c('LoginUser',{key:user.id,attrs:{"user":user,"loginHandler":_vm.loginHandler}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }